<script>
import compoment from '@/components/draggable/SmartComponents/basicComponents/Sinput/SInputPreview'
export default {
  name: 'SSPhonePreview',
  extends: compoment
}
</script>
